import Vue from 'vue';

Vue.filter('sibDateToDate', (value: string) => {
  if (!value) {
    return '<n/a>';
  }
  const date = new Date(value);

  return `${date.getDate()}.${date.getUTCMonth() + 1}.${date.getUTCFullYear()}`;
});
